import {useCallback} from 'react';
import type {CreateFlowFeatureControllerToggleProps} from '~/CreateFabricInvitation/types/types';
import {scrollElementIntoViewById} from '~/CreateFabricInvitation/utils/misc';
import {InvitationWidget} from '~/common/components/InvitationWidget/InvitationWidget';
import {EventFeature} from '~/common/types/event';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {PhotoGalleryIcon} from '~library/svg/PhotoGalleryIcon';

export const HostPhotoGalleryToggle = ({
  handleOnClick,
  active,
  hide = false,
  renderAs = 'block',
}: CreateFlowFeatureControllerToggleProps) => {
  const isLargishAndUp = useIsLargishAndUp();

  const handleClick = useCallback(() => {
    handleOnClick?.(EventFeature.HOST_PHOTO_GALLERY);
    scrollElementIntoViewById('module-host_photo');
  }, [handleOnClick]);

  return (
    <InvitationWidget.Toggle
      premiumFeature
      filled={active}
      editable={isLargishAndUp}
      title="Host photo gallery"
      subtitle="Display photos in a featured gallery."
      qaId="host-photo-gallery-toggle"
      hide={hide}
      renderAs={renderAs}
      onClick={handleClick}
      startAdornment={<PhotoGalleryIcon ratio={0.75} />}
    />
  );
};
